var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CenterContent',{attrs:{"class-object":['grey darken-1 pa-2']}},[_c('sp',{attrs:{"class-object":['white--text']}},[_vm._v(_vm._s(this.$route.path)+" is not implemented yet")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }